import { Component, Input, OnDestroy, AfterViewInit , EventEmitter} from '@angular/core'

import { appStateProvider } from '../insa-providers'
import { ReportTypeModel } from '../insa-models'
import { InsaService } from '../insa-services'
import { SharedMethodsModule } from '../insa-custom-scripts'


// TODO: it seems that multiple PDFs on the same page will not work properly due to using IDs of some elements

// declare var PDFViewerApplication: any;
let PDFViewerApplication = window['PDFViewerApplication'];
let webViewerLoad = window['webViewerLoad'];

@Component({
    selector: 'insaweb-report',
    templateUrl: 'web/viewer.html'
})
export class ReportComponent implements AfterViewInit, OnDestroy {
    @Input('customReportEvent') customReportEvent : EventEmitter<string>;
    private reportSubscriber;
    private reportTypes: ReportTypeModel[] = new Array();
    private maxReportTypeLength: number;
    private reportIsLoaded: boolean = false;
    private reportTypeHasChanged: boolean = false;

    constructor(private _insaService: InsaService, private _appStateProvider: appStateProvider) {        
    }

    ngOnInit () {
        let event = this.customReportEvent ? this.customReportEvent : this._insaService.getPdfReportEvent;
        this.reportSubscriber = event.subscribe(report => {
            this.renderReport(report);
            //needs to be here in order to stop animating after report is rendered inside view
            kendo.ui.progress($(".reportViewer-loading"), false);
           let reportTypeCombo: kendo.ui.DropDownList = $("#reportTypesCombo").data("kendoDropDownList");
            if(reportTypeCombo!==undefined){
                reportTypeCombo.enable(true)
            }
        });
        this.hideButtonsInSafari();
        kendo.ui.progress($(".reportViewer-loading"), this._appStateProvider.fetchingPDF);
    }
    
    //IGOR: reverted forcePDFviewerReinit to false, as setting it to true is not a fix, as it introduces a whole lot of additional problems,can't be used like that:
    //forcePDFviewerReinit needs to be set to true in order to avoid problem [#SRX09560]
    renderReport(report: string, forcePDFviewerReinit: boolean = false) {
        console.log(report)
        if (report !== undefined && report !== null  && report !== ""  && report !== 'ERROR') {
            var b64Array = new Uint8Array(this.base64_to_uint8array(report));
            //webViewerLoad(b64Array, forcePDFviewerReinit);
            (this.reportTypeHasChanged) ? webViewerLoad(b64Array, forcePDFviewerReinit) : webViewerLoad(b64Array, true);
            this.reportIsLoaded = true;
            $("#reportMessage").html('');
        }else {
            // clear currently loaded file
            window['PDFViewerApplication'].close()
            $("#reportMessage").html(SharedMethodsModule.noDataTemplate());
            kendo.ui.progress($(".reportViewer-loading"), false);
        }
    }

    base64_to_uint8array(s) {
        var byteChars = atob(s);
        var l = byteChars.length;
        var byteNumbers = new Array(l);

        for (var i = 0; i < l; i++) {
            byteNumbers[i] = byteChars.charCodeAt(i);
        }
        return new Uint8Array(byteNumbers);
    }

    initReportTypeCombo() {
        // FOR CUSTOM REPORTS WE DO NOT INITIALIZE COMBO!
        if (this.customReportEvent) {
            return;
        } 
        let reportTypeComboOptions: kendo.ui.DropDownListOptions = {};
        reportTypeComboOptions.dataTextField = "Description";
        reportTypeComboOptions.dataValueField = "Type";
        reportTypeComboOptions.dataSource = this.reportTypes;
        if (this._appStateProvider.selectedPartners !== undefined) {
            //fetch list of selected partners, and take the reporting type for the first one 
            //reportTypeComboOptions.value = ;
            //
        }
        reportTypeComboOptions.change = this.changeReportType.bind(this);
        $("#reportTypesCombo").kendoDropDownList(reportTypeComboOptions);
        let repDropdown = $("#reportTypesCombo").data("kendoDropDownList");
        repDropdown.list.width(this.maxReportTypeLength * 8);
        let reportTypeCombo: kendo.ui.DropDownList = $("#reportTypesCombo").data("kendoDropDownList");
        if(reportTypeCombo!==undefined){
           reportTypeCombo.enable(false) 
        }
    }

    changeReportType() {
        let reportTypeCombo: kendo.ui.DropDownList = $("#reportTypesCombo").data("kendoDropDownList");
        // for custom reports combo is anyway not shown
        if (this.customReportEvent) {
            return;
        }         
        if (this._appStateProvider.selectedPortfolios !== undefined) {
            this._insaService.getPDFReport(parseInt($("#reportTypesCombo").data("kendoDropDownList").value()));
            kendo.ui.progress($(".reportViewer-loading"), true);
            this.reportTypeHasChanged = true;
            if(reportTypeCombo!==undefined){
                reportTypeCombo.enable(false) 
            }
        } else {
            console.log("You must select portfolio/s for change portfolio type!");
        }
    }

    hideButtonsInSafari(){
        let ua = navigator.userAgent.toLowerCase(); 
        let isSafari = false;
        isSafari = (isSafari || ((ua.indexOf('safari') != -1)&& (!(ua.indexOf('chrome')!= -1) && (ua.indexOf('version/')!= -1))));
        (isSafari) ? $("#download").hide() : $("#download").show();
    }

    ngAfterViewInit() {
        let reportTypeCombo: kendo.ui.DropDownList = $("#reportTypesCombo").data("kendoDropDownList");
        this.hideButtonsInSafari();
       
        if (this._appStateProvider.fetchingPDF) {
            kendo.ui.progress($(".report-loading"), true);
            kendo.ui.progress($(".reportViewer-loading"), true);
        }
        else {
            this.renderReport(this._insaService.pdfReport, true);
           
            //stop animation after complete rendering!
            kendo.ui.progress($(".reportViewer-loading"), false);
        }
        //init report types combo
        // skip for custom reports!
       if (!this.customReportEvent && this.reportTypes.length < 1) {
            let reportTypeLength: Array<number> = new Array();
            this._insaService.getReportTypes().subscribe((data: ReportTypeModel[]) => {
                this.reportTypes = data;
                let defaultType: ReportTypeModel = {
                    "Type": -1, 
                    "Description": "Default report", 
                    "UseForConsolidated": false,
                    "Code": "",
                    "UseForOnline": true };
                this.reportTypes.splice(0,0, defaultType)
                this.maxReportTypeLength = Math.max.apply(Math, this.reportTypes.map(function (val) { return val.Description.length; }));
               this.initReportTypeCombo();
               this.enableReportCombo();
                
            });
        }
       else {
            this.initReportTypeCombo();
       }
      
    }

    private enableReportCombo(){
        let reportTypeCombo: kendo.ui.DropDownList = $("#reportTypesCombo").data("kendoDropDownList"); 
        if(reportTypeCombo!==undefined && this.reportIsLoaded){
            reportTypeCombo.enable(true);
        }else {
            reportTypeCombo.enable(false);
        }
    }

    ngOnDestroy() {
        this.reportSubscriber.unsubscribe();
    }
}


// WEBPACK FOOTER //
// ./app/insa-report/report.component.ts